/**
 * @file Controlled Drugs history table column metadata.
 */

/**
 * Column definitions for Drug History table views.
 * Maps field names to display labels.
 * @type {Object<string, string>}
 */
export const ALL_DRUG_HISTORY_COLUMNS = {
    transactionDate: 'Date',
    type: 'Type',
    drug: 'Drug',
    location: 'Location',
    quantity: 'Quantity',
    balance: 'Balance',
    notes: 'Notes',
    performedBy: 'Performed By',
    status: 'Status',
    actions: 'Actions'
};

const DRUG_HISTORY_FILTERS = {
    transactionDate: { kind: 'dateRange', valueKey: 'transactionDateValue' },
    type: { kind: 'checkboxList', valueKey: 'typeValue' },
    drug: { kind: 'checkboxList', valueKey: 'drugValues' },
    location: { kind: 'checkboxList', valueKey: 'locationValues' },
    quantity: { kind: 'numberRange', valueKey: 'quantityValues' },
    balance: { kind: 'numberRange', valueKey: 'balanceValues' },
    notes: { kind: 'keyword', valueKey: 'notesText' },
    performedBy: { kind: 'checkboxList', valueKey: 'performedByValue' },
    status: { kind: 'checkboxList', valueKey: 'statusValue' },
    actions: { kind: 'none' },
};

/**
 * Returns structured Controlled Drugs history table column metadata.
 * @param {Array<string>} visibleColumns Ordered visible column keys.
 * @returns {Array<object>} Column definitions for table rendering/filtering.
 */
export function getDrugHistoryColumnDefinitions(visibleColumns = []) {
    return visibleColumns.map((key) => ({
        key,
        label: ALL_DRUG_HISTORY_COLUMNS[key] || key,
        filter: DRUG_HISTORY_FILTERS[key] || { kind: 'none' },
    }));
}
